import React, {
  useEffect,
  useState,
} from 'react';

import {
  Link,
} from 'react-router-dom';

import axios from 'axios';

/* global process */

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL;

const AdminDashboard = () => {
  const [opportunities, setOpportunities] =
    useState([]);

  const [loading, setLoading] =
    useState(true);

  useEffect(() => {
    const loadDashboard = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/api/v1/opportunity_reviews`
        );

        setOpportunities(response.data);
      } catch (error) {
        console.error(
          'Unable to load admin dashboard.',
          error
        );
      } finally {
        setLoading(false);
      }
    };

    loadDashboard();
  }, []);

  const discovered =
    opportunities.filter(
      (item) =>
        item.review_status === 'discovered'
    ).length;

  const drafts =
    opportunities.filter(
      (item) =>
        item.review_status === 'draft'
    ).length;

  return (
    <main className="admin-page">
      <header className="admin-page-header">
        <div>
          <p className="admin-eyebrow">
            ACE Administration
          </p>

          <h1>Dashboard</h1>

          <p>
            Manage ACE content, opportunities,
            results and partnerships from one
            workspace.
          </p>
        </div>

        <Link
          to="/"
          className="admin-secondary-link"
        >
          View public website
        </Link>
      </header>

      <section className="admin-stat-grid">
        <article className="admin-stat-card">
          <span>Awaiting review</span>
          <strong>
            {loading ? '—' : discovered}
          </strong>
          <small>
            Automatically discovered
          </small>
        </article>

        <article className="admin-stat-card">
          <span>Draft opportunities</span>
          <strong>
            {loading ? '—' : drafts}
          </strong>
          <small>
            Being prepared
          </small>
        </article>

        <article className="admin-stat-card">
          <span>Active sources</span>
          <strong>2</strong>
          <small>
            Monitoring configuration
          </small>
        </article>

        <article className="admin-stat-card">
          <span>Results pillars</span>
          <strong>3</strong>
          <small>
            2026–2030 framework
          </small>
        </article>
      </section>

      <section className="admin-dashboard-grid">
        <article className="admin-panel">
          <p className="admin-panel-label">
            Quick actions
          </p>

          <h2>What would you like to do?</h2>

          <div className="admin-quick-actions">
            <Link
              to="/admin/opportunities"
              className="admin-secondary-action"
            >
              Review opportunities
            </Link>

            <Link
                  to="/admin/opportunities/new"
                  className="admin-secondary-action"
                >
                  Add opportunity manually
            </Link>

            <Link
                  to="/admin/opportunity-sources/new"
                  className="admin-secondary-action"
                >
                  Add opportunity source
                  
            </Link>

            <Link
              to="/admin/results-framework"
              className="admin-secondary-action"
            >
              Edit Results Framework
            </Link>

            <Link
              to="/admin/programme-content"
              className="admin-secondary-action"
            >
              Manage programme content
            </Link>
          </div>
        </article>

        <article className="admin-panel">
          <p className="admin-panel-label">
            Opportunity monitoring
          </p>

          <h2>Discovery pipeline</h2>

          <div className="admin-pipeline">
            <div>
              <strong>{discovered}</strong>
              <span>Discovered</span>
            </div>

            <span>→</span>

            <div>
              <strong>{drafts}</strong>
              <span>Drafts</span>
            </div>

            <span>→</span>

            <div>
              <strong>Review</strong>
              <span>Human validation</span>
            </div>

            <span>→</span>

            <div>
              <strong>Publish</strong>
              <span>Public website</span>
            </div>
          </div>
        </article>
      </section>
    </main>
  );
};

export default AdminDashboard;
